"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Alert_1 = __importDefault(require("@mui/material/Alert"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Button_1 = __importDefault(require("@mui/material/Button"));
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var FormControl_1 = __importDefault(require("@mui/material/FormControl"));
var FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
var InputLabel_1 = __importDefault(require("@mui/material/InputLabel"));
var MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
var Paper_1 = __importDefault(require("@mui/material/Paper"));
var Select_1 = __importDefault(require("@mui/material/Select"));
var Switch_1 = __importDefault(require("@mui/material/Switch"));
var Table_1 = __importDefault(require("@mui/material/Table"));
var TableBody_1 = __importDefault(require("@mui/material/TableBody"));
var TableCell_1 = __importDefault(require("@mui/material/TableCell"));
var TableHead_1 = __importDefault(require("@mui/material/TableHead"));
var TableRow_1 = __importDefault(require("@mui/material/TableRow"));
var TextField_1 = __importDefault(require("@mui/material/TextField"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var mountIsland_1 = require("../../mountIsland");
var HtmlEditorWithValue_jsx_1 = __importDefault(require("../../Generic/HtmlEditorWithValue.jsx"));
var LedMarketingPreview_1 = __importDefault(require("./LedMarketingPreview"));
// The editor offers ONLY controls whose effect survives the server-side sanitizer. No font picker,
// no colour picker: MarketingHtml strips both so the email keeps its own type system, and offering
// a control whose choice is silently discarded is worse than not offering it.
var TOOLBAR = {
    options: ['inline', 'list', 'link'],
    inline: { options: ['bold', 'italic', 'underline'] },
    list: { options: ['unordered', 'ordered'] },
    link: { options: ['link'], defaultTargetOption: '_blank' },
};
var LANG_NAMES = {
    en: 'English',
    es: 'Español',
    fr: 'Français',
    pt: 'Português',
};
var EMPTY = function (lang) { return ({
    lang: lang,
    body_html: '',
    cta_label: '',
    cta_url: '',
    image_url: '',
    image_alt: '',
    starts_on: '',
    ends_on: '',
    enabled: true,
}); };
var day = function (d) { return (d ? String(d).slice(0, 10) : ''); };
function LedMarketingPanel() {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    var bootstrapEl = document.getElementById('msia-admin-led-marketing-bootstrap');
    var props = {
        messages: [], langs: ['en', 'es', 'fr', 'pt'], activeIds: {},
        endpointStore: '', endpointBase: '', previewBase: '',
    };
    try {
        if (bootstrapEl)
            props = __assign(__assign({}, props), JSON.parse(bootstrapEl.textContent || '{}'));
    }
    catch (e) {
        console.warn('LedMarketingPanel: parse error', e);
    }
    var langs = props.langs, activeIds = props.activeIds, endpointStore = props.endpointStore, endpointBase = props.endpointBase, previewBase = props.previewBase;
    var _p = (0, react_1.useState)((_a = props.messages) !== null && _a !== void 0 ? _a : []), messages = _p[0], setMessages = _p[1];
    var _q = (0, react_1.useState)(EMPTY('en')), draft = _q[0], setDraft = _q[1];
    var _r = (0, react_1.useState)({}), errors = _r[0], setErrors = _r[1];
    var _s = (0, react_1.useState)(false), saving = _s[0], setSaving = _s[1];
    var _t = (0, react_1.useState)(null), flash = _t[0], setFlash = _t[1];
    var _u = (0, react_1.useState)(null), previewSrc = _u[0], setPreviewSrc = _u[1];
    var _v = (0, react_1.useState)(false), previewLoading = _v[0], setPreviewLoading = _v[1];
    var _w = (0, react_1.useState)(null), previewError = _w[0], setPreviewError = _w[1];
    var _x = (0, react_1.useState)(false), simplified = _x[0], setSimplified = _x[1];
    var editing = Boolean(draft.id);
    /**
     * Two messages in the same language whose date ranges overlap. The renderer resolves this on
     * its own — the one that started most recently wins — but an editor who has queued two
     * announcements over the same week almost certainly did not mean to, so say so.
     */
    var overlaps = (0, react_1.useMemo)(function () {
        var clash = new Set();
        var enabled = messages.filter(function (m) { return Boolean(m.enabled); });
        enabled.forEach(function (a) {
            enabled.forEach(function (b) {
                if (a.id === b.id || a.lang !== b.lang)
                    return;
                var aStart = a.starts_on || '0000-01-01';
                var aEnd = a.ends_on || '9999-12-31';
                var bStart = b.starts_on || '0000-01-01';
                var bEnd = b.ends_on || '9999-12-31';
                if (aStart <= bEnd && bStart <= aEnd) {
                    if (a.id)
                        clash.add(a.id);
                    if (b.id)
                        clash.add(b.id);
                }
            });
        });
        return clash;
    }, [messages]);
    var field = function (key) { return function (e) {
        var _a;
        return setDraft(__assign(__assign({}, draft), (_a = {}, _a[key] = e.target.value, _a)));
    }; };
    /**
     * The preview renders a SAVED message by id, through the same `email_preview` endpoint the feed
     * uses. That is not a compromise: the server rewrites the editor's HTML (fonts and colours are
     * stripped, pasted <div>/<table> chrome unwrapped, Georgia reapplied), so the only trustworthy
     * preview is one that goes through the real render path.
     *
     * Requiring a save first is safe, and worth being explicit about: **saving is not publishing.** A
     * message only sends when it is enabled AND inside its date range, so a disabled or future-dated
     * draft can be saved and previewed freely.
     */
    var previewUrlFor = function (m) {
        var p = new URLSearchParams({
            lang: m.lang,
            fragment: 'full',
            wrapper: 'simple-1-column-with-logo',
            message: String(m.id),
        });
        if (m.starts_on)
            p.set('on', day(m.starts_on));
        return "".concat(previewBase, "?").concat(p);
    };
    var save = function (thenPreview) {
        if (thenPreview === void 0) { thenPreview = false; }
        return __awaiter(_this, void 0, void 0, function () {
            var payload, data, _a, saved_1, e_1;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setSaving(true);
                        setErrors({});
                        setFlash(null);
                        setPreviewError(null);
                        payload = __assign(__assign({}, draft), { starts_on: draft.starts_on || null, ends_on: draft.ends_on || null, cta_label: draft.cta_label || null, cta_url: draft.cta_url || null, image_url: draft.image_url || null, image_alt: draft.image_alt || null, enabled: Boolean(draft.enabled) });
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        if (!editing) return [3 /*break*/, 3];
                        return [4 /*yield*/, axios_1.default.put("".concat(endpointBase, "/").concat(draft.id), payload)];
                    case 2:
                        _a = _d.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, axios_1.default.post(endpointStore, payload)];
                    case 4:
                        _a = _d.sent();
                        _d.label = 5;
                    case 5:
                        data = (_a).data;
                        saved_1 = data.message;
                        setMessages(function (prev) {
                            var without = prev.filter(function (m) { return m.id !== saved_1.id; });
                            return __spreadArray(__spreadArray([], without, true), [saved_1], false).sort(function (a, b) { return a.lang.localeCompare(b.lang); });
                        });
                        // The sanitizer's rewriting is invisible unless she looks. Say so once, on save, so a
                        // paste from Word does not reach an inbox looking like a surprise.
                        setSimplified(Boolean(data.simplified));
                        if (thenPreview) {
                            // Stay on the message so she can keep iterating: edit -> save & preview -> edit.
                            setDraft(__assign(__assign({}, saved_1), { starts_on: day(saved_1.starts_on), ends_on: day(saved_1.ends_on) }));
                            setPreviewLoading(true);
                            setPreviewSrc(previewUrlFor(saved_1));
                            // The iframe's own load event ends the skeleton; this is only a floor for the swap.
                            window.setTimeout(function () { return setPreviewLoading(false); }, 300);
                        }
                        else {
                            setDraft(EMPTY(draft.lang));
                        }
                        setFlash(editing ? 'Message updated.' : 'Message created.');
                        return [3 /*break*/, 8];
                    case 6:
                        e_1 = _d.sent();
                        if (((_b = e_1 === null || e_1 === void 0 ? void 0 : e_1.response) === null || _b === void 0 ? void 0 : _b.status) === 422) {
                            setErrors((_c = e_1.response.data.errors) !== null && _c !== void 0 ? _c : {});
                        }
                        else {
                            setFlash('Could not save. Please try again.');
                        }
                        return [3 /*break*/, 8];
                    case 7:
                        setSaving(false);
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    var remove = function (id) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios_1.default.delete("".concat(endpointBase, "/").concat(id))];
                case 1:
                    _a.sent();
                    setMessages(function (prev) { return prev.filter(function (m) { return m.id !== id; }); });
                    if (draft.id === id)
                        setDraft(EMPTY(draft.lang));
                    return [2 /*return*/];
            }
        });
    }); };
    var err = function (key) { var _a; return (_a = errors[key]) === null || _a === void 0 ? void 0 : _a[0]; };
    return (react_1.default.createElement(Box_1.default, { sx: { py: 3 } },
        react_1.default.createElement(Typography_1.default, { variant: "h4", gutterBottom: true }, "Loving Each Day \u2014 marketing message"),
        react_1.default.createElement(Typography_1.default, { variant: "body2", sx: { mb: 3, color: 'text.secondary' } }, "One message per language, scheduled by date. A language with no active message simply has no marketing section in its email \u2014 nothing is ever shown in the wrong language. Changes reach the next send within about an hour and a quarter (the feed is cached for 15 minutes and Mailchimp polls hourly), so schedule ahead rather than editing on the morning."),
        flash && (react_1.default.createElement(Alert_1.default, { severity: "info", sx: { mb: 2 }, onClose: function () { return setFlash(null); } }, flash)),
        react_1.default.createElement(Paper_1.default, { sx: { mb: 4 } },
            react_1.default.createElement(Table_1.default, { size: "small" },
                react_1.default.createElement(TableHead_1.default, null,
                    react_1.default.createElement(TableRow_1.default, null,
                        react_1.default.createElement(TableCell_1.default, null, "Language"),
                        react_1.default.createElement(TableCell_1.default, null, "Message"),
                        react_1.default.createElement(TableCell_1.default, null, "Runs"),
                        react_1.default.createElement(TableCell_1.default, null, "Status"),
                        react_1.default.createElement(TableCell_1.default, { align: "right" }, "\u00A0"))),
                react_1.default.createElement(TableBody_1.default, null,
                    messages.length === 0 && (react_1.default.createElement(TableRow_1.default, null,
                        react_1.default.createElement(TableCell_1.default, { colSpan: 5, sx: { color: 'text.secondary' } }, "No messages. The email currently has no marketing section in any language."))),
                    messages.map(function (m) {
                        var _a;
                        return (react_1.default.createElement(TableRow_1.default, { key: m.id },
                            react_1.default.createElement(TableCell_1.default, null, (_a = LANG_NAMES[m.lang]) !== null && _a !== void 0 ? _a : m.lang),
                            react_1.default.createElement(TableCell_1.default, { sx: { maxWidth: 340 } },
                                react_1.default.createElement("span", { style: { color: '#555' } }, (m.body_html || '').replace(/<[^>]+>/g, ' ').trim().slice(0, 90) || '—')),
                            react_1.default.createElement(TableCell_1.default, null,
                                day(m.starts_on) || 'always',
                                " \u2192 ",
                                day(m.ends_on) || 'no end'),
                            react_1.default.createElement(TableCell_1.default, null,
                                !m.enabled && react_1.default.createElement(Chip_1.default, { size: "small", label: "Disabled" }),
                                Boolean(m.enabled) && activeIds[m.lang] === m.id && (react_1.default.createElement(Chip_1.default, { size: "small", color: "success", label: "Live now" })),
                                Boolean(m.enabled) && activeIds[m.lang] !== m.id && (react_1.default.createElement(Chip_1.default, { size: "small", variant: "outlined", label: "Scheduled" })),
                                m.id && overlaps.has(m.id) && (react_1.default.createElement(Chip_1.default, { size: "small", color: "warning", sx: { ml: 1 }, label: "Overlaps", title: "Another message in this language runs over the same dates. The one that starts most recently will be the one sent." }))),
                            react_1.default.createElement(TableCell_1.default, { align: "right" },
                                react_1.default.createElement(Button_1.default, { size: "small", onClick: function () { return setDraft(__assign(__assign({}, m), { starts_on: day(m.starts_on), ends_on: day(m.ends_on) })); } }, "Edit"),
                                react_1.default.createElement(Button_1.default, { size: "small", href: previewUrlFor(m), target: "_blank" }, "Preview"),
                                react_1.default.createElement(Button_1.default, { size: "small", color: "error", onClick: function () { return m.id && remove(m.id); } }, "Delete"))));
                    })))),
        react_1.default.createElement(Paper_1.default, { sx: { p: 3 } },
            react_1.default.createElement(Typography_1.default, { variant: "h6", gutterBottom: true }, editing ? 'Edit message' : 'New message'),
            react_1.default.createElement(FormControl_1.default, { fullWidth: true, sx: { mb: 2, maxWidth: 240 } },
                react_1.default.createElement(InputLabel_1.default, { id: "lang-label" }, "Language"),
                react_1.default.createElement(Select_1.default, { labelId: "lang-label", label: "Language", value: draft.lang, onChange: function (e) { return setDraft(__assign(__assign({}, draft), { lang: e.target.value })); } }, langs.map(function (l) {
                    var _a;
                    return (react_1.default.createElement(MenuItem_1.default, { key: l, value: l }, (_a = LANG_NAMES[l]) !== null && _a !== void 0 ? _a : l));
                }))),
            react_1.default.createElement(Typography_1.default, { variant: "subtitle2", sx: { mt: 1 } }, "Message"),
            react_1.default.createElement(Box_1.default, { sx: { border: '1px solid #ccc', borderRadius: 1, p: 1, mb: 1 } },
                react_1.default.createElement(HtmlEditorWithValue_jsx_1.default, { key: (_b = draft.id) !== null && _b !== void 0 ? _b : "new-".concat(draft.lang), value: (_c = draft.body_html) !== null && _c !== void 0 ? _c : '', toolbar: TOOLBAR, paragraphs: true, onHtmlEditorStateChange: function (html) { return setDraft(function (d) { return (__assign(__assign({}, d), { body_html: html })); }); } })),
            react_1.default.createElement(Typography_1.default, { variant: "caption", sx: { color: 'text.secondary' } }, "Bold, italic, links and lists. Fonts and colours are set by the email's design, not here \u2014 the message is restyled to match the rest of the email when it is sent."),
            err('body_html') && react_1.default.createElement(Alert_1.default, { severity: "error", sx: { mt: 1 } }, err('body_html')),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 2, mt: 3, flexWrap: 'wrap' } },
                react_1.default.createElement(TextField_1.default, { label: "Button label (optional)", value: (_d = draft.cta_label) !== null && _d !== void 0 ? _d : '', onChange: field('cta_label'), error: Boolean(err('cta_label')), helperText: err('cta_label'), sx: { minWidth: 220 } }),
                react_1.default.createElement(TextField_1.default, { label: "Button link", value: (_e = draft.cta_url) !== null && _e !== void 0 ? _e : '', onChange: field('cta_url'), error: Boolean(err('cta_url')), helperText: (_f = err('cta_url')) !== null && _f !== void 0 ? _f : 'https://…', sx: { flex: 1, minWidth: 280 } })),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 2, mt: 2, flexWrap: 'wrap' } },
                react_1.default.createElement(TextField_1.default, { label: "Image URL (optional)", value: (_g = draft.image_url) !== null && _g !== void 0 ? _g : '', onChange: field('image_url'), error: Boolean(err('image_url')), helperText: (_h = err('image_url')) !== null && _h !== void 0 ? _h : 'An https:// URL on the CDN', sx: { flex: 1, minWidth: 280 } }),
                react_1.default.createElement(TextField_1.default, { label: "Image description", value: (_j = draft.image_alt) !== null && _j !== void 0 ? _j : '', onChange: field('image_alt'), error: Boolean(err('image_alt')), helperText: (_k = err('image_alt')) !== null && _k !== void 0 ? _k : 'Shown when images are blocked', sx: { flex: 1, minWidth: 280 } })),
            react_1.default.createElement(Box_1.default, { sx: { display: 'flex', gap: 2, mt: 2, alignItems: 'center', flexWrap: 'wrap' } },
                react_1.default.createElement(TextField_1.default, { label: "Starts", type: "date", value: (_l = draft.starts_on) !== null && _l !== void 0 ? _l : '', onChange: field('starts_on'), InputLabelProps: { shrink: true }, helperText: "Blank = immediately" }),
                react_1.default.createElement(TextField_1.default, { label: "Ends", type: "date", value: (_m = draft.ends_on) !== null && _m !== void 0 ? _m : '', onChange: field('ends_on'), InputLabelProps: { shrink: true }, error: Boolean(err('ends_on')), helperText: (_o = err('ends_on')) !== null && _o !== void 0 ? _o : 'Blank = runs until replaced' }),
                react_1.default.createElement(FormControlLabel_1.default, { control: react_1.default.createElement(Switch_1.default, { checked: Boolean(draft.enabled), onChange: function (e) { return setDraft(__assign(__assign({}, draft), { enabled: e.target.checked })); } }), label: "Enabled" })),
            simplified && (react_1.default.createElement(Alert_1.default, { severity: "info", sx: { mt: 3 }, onClose: function () { return setSimplified(false); } }, "Your formatting was simplified to match the email's design \u2014 fonts, colours and layout come from the template. Preview the message to see exactly how it will send.")),
            react_1.default.createElement(Box_1.default, { sx: { mt: 3, display: 'flex', gap: 2 } },
                react_1.default.createElement(Button_1.default, { variant: "contained", onClick: function () { return save(true); }, disabled: saving }, saving ? 'Saving…' : 'Save & preview'),
                react_1.default.createElement(Button_1.default, { onClick: function () { return save(false); }, disabled: saving }, editing ? 'Save changes' : 'Create message'),
                editing && (react_1.default.createElement(Button_1.default, { onClick: function () {
                        setDraft(EMPTY(draft.lang));
                        setPreviewSrc(null);
                        setSimplified(false);
                    }, disabled: saving }, "Cancel")))),
        react_1.default.createElement(LedMarketingPreview_1.default, { src: previewSrc, isLoading: previewLoading, error: previewError })));
}
var panelEl = document.getElementById('msia-admin-led-marketing-container');
if (panelEl) {
    (0, mountIsland_1.mountIsland)(panelEl, react_1.default.createElement(LedMarketingPanel, null));
}
exports.default = LedMarketingPanel;
